import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { PackagePlanOfferFieldsFragmentDoc } from '../fragments/PackagePlanOfferFields.fragment';
export type GetPackageProviderPlansQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	packages?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
	includeAddons?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetPackageProviderPlansQuery = {
	__typename?: 'Query';
	packages: Array<{
		__typename?: 'Package';
		id: string;
		clearName: string;
		planOffers: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			retailPriceConverted?: string | null;
			retailPriceValue?: number | null;
			currency?: string | null;
			presentationType?: Types.PresentationType | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
};

export const GetPackageProviderPlansDocument = gql`
	query GetPackageProviderPlans(
		$country: Country!
		$language: Language!
		$packages: [String!]
		$includeAddons: Boolean = false
	) {
		packages(country: $country, platform: WEB, packages: $packages, includeAddons: $includeAddons) {
			id
			clearName
			planOffers(country: $country, platform: WEB) {
				...PackagePlanOfferFields
			}
		}
	}
	${PackagePlanOfferFieldsFragmentDoc}
`;
